@switch (variant) {
  @case ('two-line') {
    <div class="frm-card-inline-mutation-skeleton frm-card-inline-mutation-skeleton--two-line">
      <p-skeleton styleClass="frm-card-inline-mutation-skeleton__bone frm-card-inline-mutation-skeleton__bone--primary"></p-skeleton>
      <p-skeleton styleClass="frm-card-inline-mutation-skeleton__bone frm-card-inline-mutation-skeleton__bone--secondary"></p-skeleton>
    </div>
  }
  @case ('amount') {
    <div
      class="frm-card-inline-mutation-skeleton frm-card-inline-mutation-skeleton--amount"
      [class.frm-card-inline-mutation-skeleton--amount-with-secondary]="amountSecondaryLine">
      <p-skeleton styleClass="frm-card-inline-mutation-skeleton__bone frm-card-inline-mutation-skeleton__bone--primary"></p-skeleton>
      @if (amountSecondaryLine) {
        <p-skeleton styleClass="frm-card-inline-mutation-skeleton__bone frm-card-inline-mutation-skeleton__bone--secondary"></p-skeleton>
      }
    </div>
  }
  @case ('checkbox') {
    <div class="frm-card-inline-mutation-skeleton frm-card-inline-mutation-skeleton--checkbox">
      <p-skeleton styleClass="frm-card-inline-mutation-skeleton__bone"></p-skeleton>
    </div>
  }
  @case ('switch') {
    <div class="frm-card-inline-mutation-skeleton frm-card-inline-mutation-skeleton--switch">
      <p-skeleton styleClass="frm-card-inline-mutation-skeleton__bone"></p-skeleton>
    </div>
  }
  @case ('block') {
    <div class="frm-card-inline-mutation-skeleton frm-card-inline-mutation-skeleton--block">
      <p-skeleton styleClass="frm-card-inline-mutation-skeleton__bone"></p-skeleton>
    </div>
  }
  @case ('table-cell') {
    <div class="frm-card-inline-mutation-skeleton frm-card-inline-mutation-skeleton--table-cell">
      <p-skeleton [width]="width" styleClass="frm-card-inline-mutation-skeleton__bone"></p-skeleton>
    </div>
  }
  @default {
    <div class="frm-card-inline-mutation-skeleton">
      <p-skeleton [width]="width" styleClass="frm-card-inline-mutation-skeleton__bone"></p-skeleton>
    </div>
  }
}
